import * as uk from "@/locales/yup/uk";
import { setLocale } from "yup";

import { required, integer } from "@vee-validate/rules";
import { defineRule } from "vee-validate";

export default defineNuxtPlugin({
	name: "vee-validate",
	order: 1020,
	setup: () => {
		setLocale({
			...uk,
			mixed: {
				...uk.mixed,
				required: "Це обов’язкове поле для заповнення",
			},
			string: {
				...uk.string,
				email: "Електронна адреса введена неправильно",
			},
		});

		defineRule("email_rfc_5322", (value, _, ctx) => {
			const emailRegex =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return (
				emailRegex.test(value) ||
				`Поле ${ctx.field} повинно бути валідною електронною адресою`
			);
		});

		// rule is not translated in vee-validate (4.14.7)
		defineRule("integer", (value, params, ctx) => {
			return (
				integer(value, params, ctx) ||
				`Поле ${ctx.field} повинно бути цілим числом`
			);
		});

		// rule by default doesn't accept boolean false as a valid non-empty value
		defineRule(
			"required_accept_boolean",
			(value, params, ctx) =>
				required(value === false ? true : value, params, ctx) ||
				`Поле ${ctx.field} повинно мати значення`
		);
	},
});
